import { Page } from "@/models/page-models/Page";

export const QualityDashboard: Page = {
  "path": "quality-dashboard",
  "name": "Quality Dashboard",
  "props": {
    "data": {
      "title": "Dashboard",
      "printable": "FALSE",
      "url": "quality-dashboard",
      "groups": [
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "FG",
              "bracketValueFormula": "{{fetchedData.pendingProducts.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending Products",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.pendingProducts}}",
                      "items": "fetchedData.pendingProducts.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Product #",
                          "type": "url",
                          "url": "/products/{{__item._id}}"
                        },
                        {
                          "value": "productLine",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item}})"
                        },
                        {
                          "value": "customer",
                          "text": "Customer",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "createdAt",
                          "text": "Created",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "status",
                          "text": "Status"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "updatedBy.displayName",
                          "text": "Updated By"
                        }
                      ],
                      "tableType": "static",
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve",
                          "showIf": "fn(NOT,fn(MATCH_ROLE,QA_QUALITY_EXECUTIVE))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "approveProduct",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/product/{{__item._id}}/approve",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH",
                                "arg4Key": "refreshPage",
                                "arg4Value": "TRUE"
                              },
                              "name": "approveProduct"
                            }
                          ]
                        },
                        {
                          "label": "Reject",
                          "showIf": "fn(NOT,fn(MATCH_ROLE,QA_QUALITY_EXECUTIVE))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markProductAsDraft",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/product/{{__item._id}}/mark-as-draft",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH",
                                "arg4Key": "refreshPage",
                                "arg4Value": "TRUE"
                              },
                              "name": "markProductAsDraft"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.productsForm.page",
                        "serverItemsLengthVariable": "fetchedData.pendingProducts.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.productsForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getPendingProducts",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/product/search",
                              "arg2Key": "postData",
                              "arg2Value": "fetchedData.productsForm",
                              "arg3Key": "storeInVar",
                              "arg3Value": "fetchedData.pendingProducts"
                            },
                            "name": "getPendingProducts"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "SA",
              "bracketValueFormula": "{{fetchedData.pendingSamples.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending Sample",
                      "disabled": "FALSE",
                      "items": "fetchedData.pendingSamples.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Sample",
                          "type": "url",
                          "url": "/sample/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(CONCAT,{{__item.quantity}}, ,{{__item.product.unit.unit2}},(s))"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false,
                      "pagination": {
                        "pageVariable": "fetchedData.pendingSampleSearch.page",
                        "serverItemsLengthVariable": "fetchedData.pendingSamples.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.pendingSampleSearch.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getPendingSamples",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sample/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.pendingSamples",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.pendingSampleSearch"
                            },
                            "name": "getPendingSamples"
                          }
                        ]
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "CER",
              "bracketValueFormula": "{{fetchedData.pendingCertificates.data.totalDocs}}",
              "rows": []
            },
            {
              "tabName": "CMP",
              "bracketValueFormula": "{{fetchedData.openComplaints.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Open Complaints",
                      "disabled": "FALSE",
                      "items": "fetchedData.openComplaints.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Complaint",
                          "type": "url",
                          "url": "/complaint/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.complaintType",
                          "text": "Type"
                        },
                        {
                          "value": "__item.invoice",
                          "text": "Invoice",
                          "type": "url",
                          "url": "/invoice/{{__item.invoice}}"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "__item.defectiveQuantity",
                          "text": "Defective Quantity"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Reject",
                          "showIf": "fn(MATCH_ROLE,QA_MANAGER)",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "copySelectedTableItem",
                                "type": "fnCopyData",
                                "arg1Key": "sourceKey",
                                "arg1Value": "__item",
                                "arg2Key": "destinationKey",
                                "arg2Value": "fetchedData.selectedComplaint",
                                "arg3Key": "destinationKeyType",
                                "arg3Value": "Object"
                              },
                              "name": "copySelectedTableItem"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "openRejectionPopup",
                                "type": "fnOpenPopup",
                                "arg1Key": "popupName",
                                "arg1Value": "Reject Complaint"
                              },
                              "name": "openRejectionPopup"
                            }
                          ]
                        },
                        {
                          "label": "Hold",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "holdComplaint",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/customer-complaint/{{__item._id}}/hold",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "PATCH"
                              },
                              "name": "holdComplaint"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.openComplaintSearch.page",
                        "serverItemsLengthVariable": "fetchedData.openComplaints.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.openComplaintSearch.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getOpenComplaints",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/customer-complaint/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.openComplaints",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.openComplaintSearch"
                            },
                            "name": "getOpenComplaints"
                          }
                        ]
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Transfer",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.FgRequests}})",
              "showIf": "fn(MATCH_ROLE,QA_MANAGER)",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "FG",
                      "disabled": "FALSE",
                      "items": "fetchedData.FgRequests",
                      "tableType": "static",
                      "showActions": true,
                      "headers": [
                        {
                          "value": "__item.rawMaterial._id",
                          "text": "Good#"
                        },
                        {
                          "value": "__item.rawMaterial.factoryTicket.order.product.customerName",
                          "text": "Customer"
                        },
                        {
                          "value": "__item.rawMaterial.factoryTicket.order._id",
                          "text": "Order #",
                          "type": "custom-url",
                          "width": 80,
                          "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openOrderInNewTab",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "/order/{{__item.rawMaterial.factoryTicket.order._id}}",
                                "arg2Key": "openNewTab",
                                "arg2Value": "TRUE"
                              },
                              "name": "openOrderInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "__item.rawMaterial.factoryTicket.order.product",
                          "text": "Product Description",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.rawMaterial.factoryTicket.order.product}})"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity to be Moved",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(HELPER_FN,kgToSellingUnitQuantity,{{__item.rawMaterial.factoryTicket.order}},{{__item.rawMaterial}},{{__item.quantity}}))"
                        },
                        {
                          "value": "__item.rawMaterial.factoryTicket.order.product.unit.unit2",
                          "text": "Selling Unit"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "Date Created",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        }
                      ],
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve",
                          "priority": "main",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "approveTransferRequest",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/goods/transfer/{{__item._id}}/approve",
                                "arg2Key": "postData",
                                "arg2Value": "{}"
                              },
                              "name": "approveTransferRequest"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "getPendingTransferRequests",
                                "type": "fnGetData",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/goods/transfer/pending",
                                "arg2Key": "storeInVar",
                                "arg2Value": "fetchedData.transferRequests"
                              },
                              "name": "getPendingTransferRequests"
                            },
                            {
                              "executionOrder": 3,
                              "pageFunction": {
                                "name": "getFgRequests",
                                "type": "fnCopyData",
                                "arg1Key": "sourceFn",
                                "arg1Value": "filterFgRequests",
                                "arg2Key": "destinationKey",
                                "arg2Value": "fetchedData.FgRequests"
                              },
                              "name":"getFgRequests"
                            }
                          ]
                        },
                        {
                          "label": "Reject",
                          "priority": "menu",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "rejectTransferRequest",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/goods/transfer/{{__item._id}}/reject",
                                "arg2Key": "postData",
                                "arg2Value": "{}"
                              },
                              "name": "rejectTransferRequest"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "getPendingTransferRequests",
                                "type": "fnGetData",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/goods/transfer/pending",
                                "arg2Key": "storeInVar",
                                "arg2Value": "fetchedData.transferRequests"
                              },
                              "name": "getPendingTransferRequests"
                            },
                            {
                              "executionOrder": 3,
                              "pageFunction": {
                                "name": "getFgRequests",
                                "type": "fnCopyData",
                                "arg1Key": "sourceFn",
                                "arg1Value": "filterFgRequests",
                                "arg2Key": "destinationKey",
                                "arg2Value": "fetchedData.FgRequests"
                              },
                              "name":"getFgRequests"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "70vh"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Reject Complaint",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.rejectionForm.reason",
                  "label": "Reason for rejecting",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "itemVariable": "fetchedData.selectedComplaint",      
          "popupActions": [
            {
              "label": "Reject",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "rejectComplaint",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/customer-complaint/{{__item._id}}/mark-rejected",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.rejectionForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "PATCH"
                  },
                  "name": "rejectComplaint"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeRejectionPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Reject Complaint"
                  },
                  "name": "closeRejectionPopup"
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPendingProductsParams",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPendingProductsParams",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.productsForm",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultPendingProductsParams"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getPendingProducts",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/product/search",
          "arg2Key": "postData",
          "arg2Value": "fetchedData.productsForm",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.pendingProducts"
        },
        "name": "getPendingProducts"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPendingSampleSearchForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPendingSampleSearchForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.pendingSampleSearch",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultPendingSampleSearchForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getPendingSamples",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sample/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.pendingSamples",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.pendingSampleSearch"
        },
        "name": "getPendingSamples"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultOpenComplaintSearchForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultOpenComplaintSearchForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.openComplaintSearch",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultOpenComplaintSearchForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getOpenComplaints",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/customer-complaint/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.openComplaints",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.openComplaintSearch"
        },
        "name": "getOpenComplaints"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getPendingTransferRequests",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/goods/transfer/pending",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.transferRequests"
        },
        "name": "getPendingTransferRequests",
        "executeIf": "fn(MATCH_ROLE,QA_MANAGER)"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getFgRequests",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "filterFgRequests",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.FgRequests"
        },
        "name":"getFgRequests",
        "executeIf": "fn(MATCH_ROLE,QA_MANAGER)"
      }
    ],
    "functions": [
      {
        "name": "getDefaultPendingSampleSearchForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Pending"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultPendingProductsParams",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Pending"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultOpenComplaintSearchForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Open"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "filterFgRequests",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.transferRequests.data",
        "arg2Key": "searchKey",
        "arg2Value": "rawMaterial.status",
        "arg3Key": "searchValue",
        "arg3Value": "FG"
      }
    ]
  },
  "forRole": "QA_MANAGER,QA_TECHNICAL_EXECUTIVE,QA_QUALITY_EXECUTIVE",
  "visible": true,
  "routerPriority": 100
}